module.exports = __webpack_public_path__ + "img/d1554c0f30ac6e3563b9464f50116189.svg";